const inFlightChatResumes = new Map<string, Promise<void>>();

export const singleFlightChatResume = ({
  chatId,
  resume,
  onError,
}: {
  chatId: string;
  resume: () => unknown;
  onError?: (error: unknown) => void;
}): Promise<void> => {
  const inFlight = inFlightChatResumes.get(chatId);

  if (inFlight) {
    return inFlight;
  }

  const next: Promise<void> = new Promise<unknown>((resolve) =>
    resolve(resume()),
  )
    .then(
      () => undefined,
      (error: unknown) => {
        onError?.(error);

        throw error;
      },
    )
    .finally(() => {
      if (inFlightChatResumes.get(chatId) === next) {
        inFlightChatResumes.delete(chatId);
      }
    });

  inFlightChatResumes.set(chatId, next);

  return next;
};
